import './styles.scss';
import { FiChevronLeft } from '@react-icons/all-files/fi/FiChevronLeft';
import { FiChevronRight } from '@react-icons/all-files/fi/FiChevronRight';
import React, { useCallback, useState } from 'react';
import SwipeableViews from 'react-swipeable-views';

const ImageCarousel: React.FC<{ images: string[] }> = ({ images }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const handleNext = useCallback(
    (e) => {
      e.preventDefault();
      setActiveIndex((index) => (index === images.length - 1 ? 0 : index + 1));
    },
    [images]
  );
  const handlePrev = useCallback(
    (e) => {
      e.preventDefault();
      setActiveIndex((index) => (index === 0 ? images.length - 1 : index - 1));
    },
    [images]
  );

  const [showControls, setShowArrows] = useState(false);
  const handleMouseEnter = useCallback(() => setShowArrows(true), []);
  const handleMouseLeave = useCallback(() => setShowArrows(false), []);

  return (
    <SwipeableViews
      className="product-detail-modal-swipeable-images"
      index={activeIndex}
      autoPlay={false}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {images.map((image) => (
        <div className="position-relative">
          <img src={image} />
          {images.length > 1 && (
            <span
              className={
                'product-detail-modal-swipeable-prev' +
                (showControls ? ' mouseover' : '')
              }
              onClick={handlePrev}
            >
              <FiChevronLeft size={24} />
            </span>
          )}
          {images.length > 1 && (
            <span
              className={
                'product-detail-modal-swipeable-next' +
                (showControls ? ' mouseover' : '')
              }
              onClick={handleNext}
            >
              <FiChevronRight size={24} />
            </span>
          )}
        </div>
      ))}
    </SwipeableViews>
  );
};

export default ImageCarousel;
